export default (node:any, options:any) => {
  node.attribs['href'] = window.location.toString().split('#', 1)[0] + node.attribs['href'] 
  return node
}